import { createBrowserRouter, RouterProvider, Link, Outlet } from 'react-router-dom';
import { useAuth, RedirectToSignIn } from '@clerk/clerk-react';
import Catalog from './pages/Catalog';
import DropDetail from './pages/DropDetail';
import Confirmation from './pages/Confirmation';
import Dashboard from './pages/Dashboard';

function ProtectedRoute() {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) return null;
  if (!isSignedIn) return <RedirectToSignIn />;
  return <Outlet />;
}

function Layout() {
  return (
    <>
      <nav>
        <Link to="/">Catalog</Link>
        {' | '}
        <Link to="/dashboard">Dashboard</Link>
      </nav>
      <Outlet />
    </>
  );
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
     { index: true, element: <Catalog /> },
{ path: 'drop/:slug', element: <DropDetail /> },
{
  element: <ProtectedRoute />,
  children: [
    { path: 'dashboard', element: <Dashboard /> },
    { path: 'confirmation/:sessionId', element: <Confirmation /> },
  ],
},
        ],
      },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
